import { AdminType, APIGet, APIPost, APIPut, APIUrl, StatusCode } from "api/protocols";
import { CancelToken } from "axios";

interface IGetOrder {
  id?: number;
  search?: string;
  number?: string;
  customer_id?: number;
  extended?: boolean;
  refund?: boolean;
  limit?: number;
  offset?: number;
  filters?: Array<Record<string, any>>;
  food_orders?: boolean;
}

// GET Order
// Retrieve a list of orders for a facility
// extended: boolean
export async function GetOrder(params: IGetOrder, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/order"), params, useGlobalLoader, token);
}

interface IPostOrder {
  customer_id: number;
}

interface IPostOrderRes {
  status: StatusCode;
  data: {
    id: number;
  };
}

// POST Order
// Create a new order
export async function PostOrder(params: IPostOrder, useGlobalLoader: boolean): Promise<IPostOrderRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/order"), params, useGlobalLoader);
}

// POST Line Items
// Add a new line to an order
interface IPostLineItemsToOrder {
  order_id: number;
  variant_id: number;
  quantity: number;
}

interface IPostLineItemsToOrderRes {
  status: StatusCode;
  data: any;
}

export async function PostLineItemsToOrder(
  params: IPostLineItemsToOrder,
  useGlobalLoader: boolean,
): Promise<IPostLineItemsToOrderRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/order/line-item"), params, useGlobalLoader);
}

interface IPutOrderComplete {
  order_id: number;
  gift_cards: {
    cart_line_item_id: number;
    code: string;
    pin: number;
    random: boolean;
    gift_card_restrict_facility?: boolean;
  }[];
  register_id?: number;
  league_ids?: Array<number>;
  tournament_ids?: Array<number>;
}

interface IPutVoidOrder {
  order_id: number;
  notes?: string;
  financial_status?: string;
  void_note?: string;
}

interface IPutReinstateOrder {
  order_id: number;
}

export async function GetLineItem(params: any, useGlobalLoader?: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/order/line-item"), params, useGlobalLoader);
}
// PUT Order
// Update some attributes on an order
export async function PutOrder(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order"), params, useGlobalLoader);
}

interface IPutOrderTip {
  order_id: number;
  cash_tip: number;
  allocations?: Array<{ user_id: number; amount: number }>;
}

export async function PutOrderTip(params: IPutOrderTip, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/tip"), params, useGlobalLoader);
}

interface IPutOrderTipAllocations {
  order_id: number;
  tip_type: "card" | "cash";
  allocations: Array<{ user_id: number; amount: number }>;
}

export async function PutOrderTipAllocations(params: IPutOrderTipAllocations, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/tip-allocations"), params, useGlobalLoader);
}

export async function GetReceipt(
  params: { id: number; tee_time_id?: number; type?: string, ticket_stub_ids?: Array<number> },
  useGlobalLoader?: boolean,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/order/receipt"), params, useGlobalLoader);
}

export async function GetPrintBulkReceipts(
  params: { receipts: Array<{id: number; type: "cart" | "order"}>, tee_time_id?: number; },
  useGlobalLoader?: boolean,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/order/receipt/bulk"), params, useGlobalLoader);
}

export async function PutOrderComplete(params: IPutOrderComplete, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/complete"), params, useGlobalLoader);
}

export async function PutVoidOrder(params: IPutVoidOrder, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/void"), params, useGlobalLoader);
}

export async function PutReinstateOrder(params: IPutReinstateOrder, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/reinstate"), params, useGlobalLoader);
}

//Email Order Receipt
export async function EmailReceipt(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/receipt/email"), params, useGlobalLoader);
}

export async function GetItemSalesSummary(
  params: { customer_id: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/order/summary"), params, useGlobalLoader, token);
}

export async function GetOrderAudits(params: { order_id: number }, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/order/audit"), params, useGlobalLoader);
}

export interface IERangePin {
  id: number;
  facility_id: number;
  order_id: number;
  order_line_item_id: number;
  variant_id: number;
  pin: string;
}
export async function GetERangePins(params: { order_id: number }) {
  return await APIGet<IERangePin[]>(APIUrl(AdminType.FacilityAdmin, "/order/e-range-pins"), params, false);
}
export async function PrintERangePins(params: { order_id: number; e_range_pin_id?: number }, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/order/e-range-pins/print"), params, useGlobalLoader);
}
export async function PutERangePinRegenerate(params: { e_range_pin_id: number }) {
  return await APIGet<IERangePin>(APIUrl(AdminType.FacilityAdmin, "/order/e-range-pins/regenerate"), params, false);
}
